// frontend/src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";

/**
 * Sentry error tracking (P21-G5). Disabled unless VITE_SENTRY_DSN is set, so
 * dev builds without a DSN send nothing. The DSN is a build-time Vite env var
 * (baked into the bundle); leave it empty locally.
 */
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}

/**
 * Entry point — wraps the app in AuthProvider so auth state is available
 * throughout the component tree. The Sentry ErrorBoundary catches render-time
 * errors below it and (when configured) reports them, showing a minimal
 * fallback instead of a blank white screen.
 */
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <p style={{ padding: "2rem", textAlign: "center" }}>
          Something went wrong. Please refresh the page.
        </p>
      }
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
